import { populate } from 'populate'; import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'CropAmaranth',
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: 'daf36083-237f-4abc-b35a-b8c76538bc28',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: 'fc4489a2-fa1b-406d-ba54-7711cb942e39',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'my_farm_soil',
      parent: 'daf36083-237f-4abc-b35a-b8c76538bc28',
      data: ''
    },
    {
      id: 'dd33a16c-811f-4954-a8a5-32234bf1f80a',
      type: 'Sprite',
      name: 'item',
      nameSpace: '',
      className: '',
      x: -3,
      y: 14,
      anchor: {
        x: 0.5,
        y: 0.95
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'small_crops_amaranth',
      parent: 'daf36083-237f-4abc-b35a-b8c76538bc28',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class CropAmaranth {
  static raw = raw;
  root: PIXI.Container
  item: PIXI.Sprite

  constructor() {
    populate(this, raw);
  }
}
